// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__YAyMs","itemTitle":"ClientEmergencyInfo_itemTitle__vW5T-","itemText":"ClientEmergencyInfo_itemText__3WWPX"};